module.exports = __webpack_public_path__ + "static/media/tests.1b9547cd.png";